import type { NestErrorResponse } from '../types';

const VALIDATION_ERROR_STATUS_CODE = 400;

export function isValidationError(res?: NestErrorResponse) {
  return res?.statusCode === VALIDATION_ERROR_STATUS_CODE && Array.isArray(res?.message);
}
